import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import { useProductDetailQueryParams } from '../../../../hooks/use-product-detail-query-params.js';
import { ChannelAvailability } from '../../../../types/product.js';
import { isRxProductAction } from '../../../../types/typeguards.js';
import { getSelectedOffering } from '../../utils/get-selected-offering.js';
import { getFramesDisplayPrice } from '../utils/get-frames-display-price.js';

const FramesEcommContext = /*#__PURE__*/ React.createContext({});
const useFramesEcommContext = ()=>React.useContext(FramesEcommContext)
;
const FramesEcommProvider = ({ children  })=>{
    var ref;
    const { activeVariant: { channelAvailability , sku  } , displayPrice: unmodifiedDisplayPrice , product ,  } = useProductData();
    const { isPrescriptionGlassesEnabled , isRxPriceFromEnabled  } = useFeatureToggles();
    const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
    const handleConfiguratorOpen = ()=>{
        setIsConfiguratorOpen(true);
    };
    const handleConfiguratorClose = ()=>{
        setIsConfiguratorOpen(false);
    };
    const { filteredOfferings , isReimbursable  } = useProductDetailQueryParams();
    const offerings = (ref = product.offerings) === null || ref === void 0 ? void 0 : ref.filter((offering)=>isReimbursable ? offering.isInsuranceReimbursable : !offering.isInsuranceReimbursable
    );
    const [selectedOffering, setSelectedOffering] = React.useState(getSelectedOffering(offerings, filteredOfferings));
    const [sspTotalPrice, setSspTotalPrice] = React.useState();
    const displayPrice = getFramesDisplayPrice(unmodifiedDisplayPrice, selectedOffering, !isPrescriptionGlassesEnabled ? sspTotalPrice : undefined);
    const productAction = React.useMemo(()=>{
        const fallbackAction = channelAvailability === ChannelAvailability.ONLINE && isPrescriptionGlassesEnabled ? 'OPEN_CONFIGURATOR' : 'OPEN_CONFIGURATOR_UNAVAILABLE';
        const variantAction = selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.actions.find((action)=>action.variantSku === sku
        );
        return variantAction ? variantAction.action : fallbackAction;
    }, [
        isPrescriptionGlassesEnabled,
        channelAvailability,
        selectedOffering,
        sku
    ]);
    const shouldDisplayFromPrice = Boolean(isRxPriceFromEnabled && isRxProductAction(productAction));
    const value = {
        productAction,
        isConfiguratorOpen,
        handleConfiguratorOpen,
        handleConfiguratorClose,
        offerings,
        selectedOffering,
        setSelectedOffering,
        displayPrice,
        setSspTotalPrice,
        shouldDisplayFromPrice
    };
    return /*#__PURE__*/ React.createElement(FramesEcommContext.Provider, {
        value: value
    }, children);
};

export { FramesEcommContext, FramesEcommProvider, useFramesEcommContext };
//# sourceMappingURL=FramesEcommContext.js.map
